import React from "react";
import PropTypes from "prop-types";
import ReactSwipeEvents from "react-swipe-events";

import x from "./x.svg";
import { CompaniesFilter } from "./CompaniesFilter";
import { TypesFilter } from "./TypesFilter";
import { Transports } from "./Transports/Transports";
import styles from "./Sidebar.module.scss";
import {Static} from "./Statics";

function SidebarContent({ close }) {


  return (
    <ReactSwipeEvents onSwipedLeft={close}>
      <div style={{display: 'flex', flexDirection: 'column'}}>
          <div className={styles.box} style={{marginBottom: '10px'}}>
            <div className={styles.groupTitle}>
              Фильтры:
            </div>
            <button
              type="button"
              onClick={close}
              className={styles.closeButton}
              title="Закрыть меню"
            >
              <img src={x} alt="Закрыть меню" />
            </button>
          </div>
        <CompaniesFilter />
        <TypesFilter />
        <Static/>
        <div className={styles.box} style={{
            marginBottom: '6px',
            marginTop: '40px'
        }}>
          <div className={styles.groupTitle}>Список ТС на линии:</div>
        </div>
        <Transports />
      </div>
    </ReactSwipeEvents>
  );
}

SidebarContent.propTypes = {
  close: PropTypes.func.isRequired,
};

export { SidebarContent };
